import { useGLTF } from '@react-three/drei'
import { gltfAsset } from '../../assetStore'

export function StartArea() {
    const { scene } = useGLTF(gltfAsset.StartArea)
    return (
        <primitive object={scene} />
    )
}
